import { Component, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUser, UsersApi } from '@tytapp/api';
import { UserService } from '@tytapp/user';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: `tyt-change-email`,
    templateUrl: './change-email.component.html',
    styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent {
    constructor(
        private userService: UserService,
        private router: Router,
        private userApi: UsersApi
    ) {
    }

    submitting = false;
    subscriptions = new Subscription();
    user: ApiUser;
    emailError: string;
    accountSuccess: string;
    newEmail: string;
    newEmail2: string;
    genericErrorMessage = 'An unknown error occurred. Please try again, if this issue persists contact support@tytnetwork.com';

    @Output() emailChanged = new Subject<void>();
    @Output() canceled = new Subject<void>();

    ngOnInit() {
        this.subscriptions.add(this.userService.userChanged.subscribe(user => this.user = user));
    }

    async submit() {
        this.emailError = null;
        this.accountSuccess = null;

        if (!this.newEmail) {
            this.emailError = 'Please enter the email address you would like to use.';
            return;
        }

        if (this.newEmail != this.newEmail2) {
            this.emailError = 'The email address you provided does not match the confirmation.';
            return;
        }

        let emailError = this.userService.validateEmail(this.newEmail);
        if (emailError) {
            this.emailError = emailError;
            return;
        }

        this.submitting = true;

        try {
            await this.userApi.updateUser({ email: this.newEmail }).toPromise();
            this.user.email = this.newEmail;
            this.userService.locallyUpdateUser(this.user);

        } catch (e) {
            if (e.json)
                e = e.json();

            this.submitting = false;
            this.emailError = e.message || e.error || this.genericErrorMessage;
            return;
        }

        this.accountSuccess = 'Your email address has been changed.';
        this.submitting = false;

        this.emailChanged.next();

    }
}